import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteBookingBookmark } from '@/features/auth'

export const useBookingBookmarkDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteBookingBookmark,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getBookingBookmarks'],
      })
    },
  })
}
